/** Sieve — product-level constants. */

export const BRAND = 'Sieve';
export const SHARE_DOMAIN = 'sievedaily.com';
export const SHARE_URL = `https://${SHARE_DOMAIN}`;

// Re-export the locked gameplay invariants (§17) so UI code has one import.
export {
  GRID_SIZE,
  CELL_COUNT,
  PRIME_COUNT,
  GIMME_COUNT,
  TRAP_COUNT,
  MISTAKE_BUDGET,
} from '../engine/grid';

/** The current persistence schema version. v2 adds the Multiples namespace (§9). */
export const SCHEMA_VERSION = 2;
